import BackendProxy from "@/BackendProxy";
import ImagePreloader from 'image-preloader-promise';
import Rnd from '@/Rnd';
import axios from 'axios';

export default class Boot {
  static bannerId;
  static app;

  constructor() {

  }

  init() {
    const ratio = Boot.pixelRatio = Math.min(2, Math.floor(window.devicePixelRatio || 1));

    Boot.bannerId = Rnd.integer(1, 7);

    const suffix = ratio == 1 ? '' : '@2x';
    const images = [
      `/static/images/car-icon${suffix}.png`,
      `/static/images/claim${suffix}.png`,
      `/static/images/countdownback${suffix}.png`,
      `/static/images/electron${suffix}.png`,
      `/static/images/energy-cloud${suffix}.png`,
      `/static/images/header-back${suffix}.png`,
      `/static/images/keyvisual-back${suffix}.png`,
      `/static/images/keyvisual-overlay${suffix}.png`,
      `/static/images/map${suffix}.png`,
      `/static/images/city-spot-overlay${suffix}.png`,
      `/static/images/city-spot-copy${suffix}.png`,
      `/static/images/instagram-icon${suffix}.png`,
      `/static/images/banner-l-${Boot.bannerId}${suffix}.jpg`,
      `/static/images/banner-r-${Boot.bannerId}${suffix}.jpg`,
      `/static/images/cars.png`,
      `/static/images/flash.png`,
      `/static/images/smart-logo${suffix}.png`
    ];

    return new Promise((resolve, reject) => {
      axios.get('/static/config.json').then((data) => {
        BackendProxy.url = data.data.url;
        new BackendProxy()
          .init()
          .then(() => {
            ImagePreloader.preloadImages(images)
              .then((status) => {
                resolve();
              })
              .catch(() => {
                reject();
              });
          })
          .catch((err) => {
            console.log('err', err);
          });
      })
        .catch((e) => {

        });


    });

  }
}



// WEBPACK FOOTER //
// ./src/Boot.js